import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const pid = localStorage.getItem("tp_active_project");
  if (pid && config.method === "get") {
    config.params = { ...(config.params || {}), project_id: pid };
  }
  if (pid && ["post", "put", "delete"].includes(config.method)) {
    config.params = { ...(config.params || {}), project_id: pid };
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "حدث خطأ ما، حاول مرة أخرى.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
